module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/095-pitcairn-islands-323effa8eb483d3344bca187722ba8af.svg";